import PurchaseEntry from "./Purchase/PurchaseEntry";
import PurchaseReturnEntry from "./Purchase/PurchaseReturnEntry";
import Report from "./Report";
import SalesEntry from "./Sales/SalesEntry";
import SalesReturnEntry from "./Sales/SalesReturnEntry";

export default {
  SalesEntry,
  PurchaseEntry,
  SalesReturnEntry,
  PurchaseReturnEntry,
  Report,
};
